/* globals window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import Divider from '../Widgets/Divider';

import MenuItem from './MenuItem';
import Wrapper from './Wrapper';

export default class LeftHandNav extends Component {
    static displayName = displayName('LeftHandNav/LeftHandNav');

    static propTypes = {
        links: PropTypes.array.isRequired,
        withoutReactRouterLinks: PropTypes.bool,
        isDashboards: PropTypes.bool,
        withSubmenu: PropTypes.bool,
    };

    static contextTypes = {
        location: PropTypes.object,
    };

    static defaultProps = {
        isDashboards: false,
        withSubmenu: true,
        withoutReactRouterLinks: false,
    };

    /* eslint-disable react/no-array-index-key */
    renderLinks = () => this.props.links.map((link, idx) => {
        if (link.name) {
            let isActive;

            // don't want the left hand nav active when creating new items
            // and this is the only path that currently gets isActive set incorrectly
            if (window.location.pathname === '/hold_reasons/new') {
                isActive = false;
            } else if (window.location.pathname.includes('/ui/results')) { // search details are not 'ui/searches'
                isActive = link.type === 'searches';
            } else {
                isActive = window.location.pathname.includes(link.path);
            }

            return (
                <MenuItem
                    isActive={isActive}
                    withoutReactRouterLinks={this.props.withoutReactRouterLinks}
                    key={link.path}
                    {...link}
                />
            );
        }

        return <Divider data-tag="divider" key={`divider${idx}`} />;
    });
    /* eslint-enable react/no-array-index-key */

    render() {
        return (
            <Wrapper isDashboards={this.props.isDashboards} withSubmenu={this.props.withSubmenu}>
                {this.renderLinks()}
            </Wrapper>
        );
    }
}
